import { RootState } from 'state/store';
import { useSelector } from 'state/storeHooks';

import { getBrowserLocale } from 'utils/locale';

const DEFAULT_LOCALE = 'en-US';

/**
 * Returns the effective locale code.
 *
 * Pure selector — reads from Redux only. No side effects, no URL access.
 *
 * Precedence (managed externally, before this hook is called):
 *   1. Redux state.locale.localeCode  — seeded from ?locale= by AppWrapper on
 *      mount, then owned by LanguageSwitcher / property default
 *   2. navigator.language             — mapped to a supported locale
 *   3. 'en-US'                        — hard fallback
 *
 * URL seeding lives in AppWrapper (single place, runs once on mount).
 */
export function useLocale(): string {
  const storedLocale = useSelector((state: RootState) => state.locale?.localeCode);
  return storedLocale || getBrowserLocale() || DEFAULT_LOCALE;
}
